import { render, staticRenderFns } from "./service-plans.vue?vue&type=template&id=db339ad6&scoped=true"
import script from "./service-plans.vue?vue&type=script&lang=js"
export * from "./service-plans.vue?vue&type=script&lang=js"
import style0 from "./service-plans.vue?vue&type=style&index=0&id=db339ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db339ad6",
  null
  
)

export default component.exports